import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openCustomDialog } from '../../../redux/slices/customDialogSlice';
import FormEdit from '../../../app/form/form/FormEdit';

const EditFormAction = ({ payload, onComplete }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        const onClose = onComplete ? () => onComplete(null) : undefined;
        dispatch(
            openCustomDialog(<FormEdit form={payload} onSubmit={onComplete} onCancel={onClose} />, { 
                beforeClose: onClose,
            })
        );
        // eslint-disable-next-line
    }, []);
};

export default EditFormAction;
